import { intersect, partial, string, struct } from 'io-ts/Decoder';

import * as chat from '../../../chat';

export const Request = intersect(
	struct({
		content: string,
	})
)(
	partial({
		metadata: chat.message.Metadata,
	})
);
